export * from './room-group-carousel-item';
export * from './room-group-details';

import { RoomGroupCarouselItemComponent } from './room-group-carousel-item';
import { RoomGroupDetailsComponent } from './room-group-details';

export const RoomGroupAtoms = [
    RoomGroupCarouselItemComponent,
    RoomGroupDetailsComponent
]